import React, { useEffect } from "react";
import { format } from "date-fns";
import MatUITable from "../../../components/MatUITable/MatUITable";
import Heading from "../../../components/Heading/Heading";
import axios from "../../../utils/Axios/axiosProxy";
import { UserDashboardContext } from "../UserDashboard";
import { userSupportColumns } from "../../../utils/Data/dataTexts";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function UserSupport({ ...props }) {
  const [messages, setMessages] = React.useState([]);
  const dashboardContext = React.useContext(UserDashboardContext);

  useEffect(() => {
    const createTableData = (messages) => {
      let rowData = [];
      for (let key in messages.threads) {
        let msgArr = messages.threads[key].messages;
        let length = msgArr.length;
        if (length > 0) {
          let seen =
            msgArr[length - 1].sender === "admin"
              ? msgArr[length - 1].seen
              : true;
          rowData.push({
            threadID: messages.threads[key]._id,
            sent: format(new Date(msgArr[length - 1].date), "yyyy-MM-dd"),
            message: `${msgArr[length - 1].message.substring(0, 20)} ...`,
            dialogData: messages.threads[key],
            seen: seen,
            userID: messages.userID,
          });
        } else {
          rowData.push({
            threadID: messages.threads[key]._id,
            threadIDDisplay: messages.threads[key]._id,
            sent: format(new Date(), "yyyy-MM-dd"),
            message: i18n.t("matable.nomsg"),
            dialogData: messages.threads[key],
            userID: messages.userID,
          });
        }
      }
      setMessages(rowData);
    };
    createTableData(props.messages);
  }, [props.messages]);

  const startNewThread = (userID) => {
    let data = { userID: userID };
    axios
      .patch("/api/communication/thread", data, {
        headers: {
          /* Authorization: `Bearer ${JWT}`, */
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("NEW THREAD RESPONSE: ", response.statusText);
        dashboardContext.updateMessages(response.data.messages);
      })
      .catch((error) => {
        console.log("NEW THREAD ERROR: ", error);
      })
      .catch((error) => console.log("NEW THREAD CLIENT ERROR", error));
  };
  console.log(messages);
  return (
    <div className="DashboardContent">
      <Heading
        title={i18n.t("general.messages")}
        button
        titleB={i18n.t("general.newmessage")}
        onClick={() => startNewThread(props.messages.userID)}
        className="ToreaBay Medium"
      />
      <MatUITable
        paging={true}
        page="support"
        columns={userSupportColumns}
        data={messages}
      />
    </div>
  );
}

export default withTranslation()(UserSupport);
